module.exports = __webpack_public_path__ + "static/media/sheep-attack.36b17e93.jpg";